export const transformProductRecommendation = (product) => {
    const url = new URL(product.slugUrl, window.location.origin)
    const productUrl = url.pathname.replace('/s/Cavenders', '')

    return {
        c_cloudinary: product.c_cloudinary || '',
        c_productURL: productUrl,
        c_promotionMessage: product.c_promotionMessage,
        currency: product.currency || '',
        hitType: 'master',
        image: product.image || {},
        imageGroups: product.imageGroups || '',
        price: product.price || '',
        pricePerUnit: product.pricePerUnit || '',
        priceRanges: product.priceRanges || [],
        productId: product.id || '',
        productName: product.name || '',
        productPromotions: product.productPromotions || '',
        productType: {
            master: (product.type && product.type.master) || ''
        },
        representedProduct: {id: product.variants?.[0]?.productId || ''},
        variants:
            product.variants?.map((variant) => ({
                ...variant,
                productPromotions: product.productPromotions
            })) || [],
        variationAttributes: product.variationAttributes || ''
    }
}
